export default "__VITE_ASSET__1VE$nd1N__"